import { EOfferType, EDealType, EObjectType, ERentTime, IJsonQuery } from './jsonQuery';

/**
 * Определение типа сделки по jsonQuery
 */
export const dealTypeFromJsonQuery = (jsonQuery: IJsonQuery): EDealType => {
  const type = jsonQuery._type;
  const rentTime = jsonQuery.for_day && jsonQuery.for_day.value;

  if (type.endsWith('sale')) {
    return EDealType.Sale;
  }

  if (type.endsWith('rent')) {
    if (rentTime === ERentTime.NotDaily) {
      return EDealType.RentLongterm;
    }

    return EDealType.Rent;
  }

  /* istanbul ignore next */
  return EDealType.Unexpected;
};

/**
 * Определение типа предложения по jsonQuery
 */
export const offerTypeFromJsonQuery = (jsonQuery: IJsonQuery): EOfferType => {
  const dealType = dealTypeFromJsonQuery(jsonQuery);

  const objectType = jsonQuery.object_type && jsonQuery.object_type.value;

  if (objectType) {
    let offerType = EOfferType.Unexpected;

    if (objectType.includes(EObjectType.House)) {
      offerType |= EOfferType.House;
    }
    if (objectType.includes(EObjectType.Housepart)) {
      offerType |= EOfferType.HousePart;
    }
    if (objectType.includes(EObjectType.Townhouse)) {
      offerType |= EOfferType.Townhouse;
    }
    if (objectType.includes(EObjectType.Land)) {
      if ((dealType & EDealType.Rent) === 0) {
        offerType |= EOfferType.Land;
      }
    }

    return offerType;
  }

  return EOfferType.Suburban;
};

/**
 * Check is urban category
 * @param {EOfferType} offerType
 */
export function isUrban(offerType: EOfferType) {
  return (offerType & EOfferType.Urban) !== 0;
}

/**
 * Check is suburban category
 * @param {EOfferType} offerType
 */
export function isSuburban(offerType: EOfferType) {
  return (offerType & EOfferType.Suburban) !== 0;
}

/**
 * Check is commercial category
 * @param {EOfferType} offerType
 */
export function isCommercial(offerType: EOfferType) {
  return (offerType & EOfferType.Commercial) !== 0;
}

/**
 * Check is residential category
 * @param {EOfferType} offerType
 */
export function isResidential(offerType: EOfferType) {
  return (offerType & EOfferType.Residential) !== 0;
}

/**
 * Check is flat category
 * @param {EOfferType} offerType
 */
export function isFlat(offerType: EOfferType) {
  return (offerType & EOfferType.Flat) !== 0;
}
